<template>
  <div>
    <v-card id="projectCard">
      <v-card-text
        class="pa-0"
        style="position: relative"
      >
        <v-img
          aspect-ratio="1.6"
          :lazy-src="src"
          :src="src"
        />
        <button-dialog-delete
          v-if="deletable"
          color=""
          :icon="true"
          icon-mdi="mdi-close"
          :icon-only="true"
          :icon-xs="true"
          :no-text="true"
          :text="$t('popup.schedule')"
          @ok-pushed="remove()"
        />
      </v-card-text>
      <v-card-title class="py-2">
        <v-container
          class="pa-0"
          fluid
        >
          <v-row>
            <v-col
              sm="7"
              xl="8"
            >
              <v-row>
                <v-col class="pb-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        class="body-1 text-truncate"
                        v-on="on"
                      >
                        <slot />
                      </div>
                    </template>
                    <span> <v-icon class="mr-2">mdi-file-document-outline</v-icon>{{ cardData.name }} </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <div class="caption text-truncate">{{ width }}x{{ height }}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              align-self="center"
              class="text-right"
              sm="5"
              xl="4"
            >
              <v-btn
                fab
                depressed
                small
                @click="openProject()"
              >
                <v-icon>mdi-file-document-edit-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector";
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector";

// Tools
const pathInfo = require("path");
const ft = require("@/components/Tools/FileTools");

export default {
  components: {
    buttonDialogDelete,
  },
  props: {
    cardData: {
      type: Object,
      default: () => {},
    },
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profileFavouriteConnector: new ProfileFavouriteConnector(this.$store.state.user),
      projectConnector: new ProjectConnector(this.$store.state.user),
    };
  },
  computed: {
    width() {
      return this.cardData.width;
    },
    height() {
      return this.cardData.height;
    },
    src() {
      let source = require("../../assets/icon/default.png");
      if (this.cardData.id !== undefined && this.cardData.id !== 0) {
        source = "./mediacenter/tmb/" + this.cardData.id + ".png?t=" + Date.now().toString();
      }
      return source;
    },
  },
  methods: {
    openProject() {
      const templateData = {
        projectName: this.cardData.name,
        savePath: this.cardData.path,
      };

      // check if template before adding template in project history
      if (!this.cardData.path.includes("mediacenter/share/")) {
        this.profileFavouriteConnector.insertHistProjectByFilepath(templateData.savePath);
      }

      this.$store.dispatch("open", templateData).project;
      this.$router.push({ path: "/project/1" });
    },
    remove() {
      // TODO: Do this a better way
      const path = this.cardData.path.replace(".\\", "").replace("./", "").split("\\").join("/");

      // Confirm we try to delete a project
      if (pathInfo.extname(path) == ".zip") {
        this.projectConnector
          .getProjectInSchedule(path)
          .then((isScheduled) => {
            if (isScheduled) {
              this.$store.dispatch("openSnackbar", {
                title: this.$t("dialog.warning"),
                txt: this.$t("popup.project-scheduled"),
                colorBg: "red",
              });
            } else {
              ft.remove("./" + path)
                .then(() => {
                  this.projectConnector.deleteProject(this.cardData.id);
                  this.profileFavouriteConnector.deleteHistProject(this.cardData.id);
                  this.$emit("refresh");
                })
                .catch((err) => {
                  console.error(err);
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style>
#projectCard .deleteBtn {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
